import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterTag_template} from "./filterTag_template";
import {filterDropdown_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

interface Tag {
    id: number,
    name: string,
    type: Type,
    formattedTagTypeAndDataset: string
}
interface Type {
    formattedDataset: string,
}
interface Field {
    id: number,
    label: string
}
interface InclusionRule {
    id?: number,
    tag: Tag,
    field: Field
}

export class inclusionRules_template extends vnTemplate {

    protected tagTypeFieldsFilter: filterDropdown_template;
    protected tagFilter: filterTag_template;
    protected tooltip: infoButton_template;


    protected inclusionRuleTooltipContent = `
        <p>
        This selection is mandatory and determines how the tags will be organized on the listing page. All valid combinations will be created as pages.
        </p>
        `

    //
    // implementation of base class [vnTemplate]
    protected getTemplateHtml(): string {

        return `
                   
                <div class="form-group"><hr></div>
                <div class="from-group" style="text-align:left;margin: 0 2rem 2rem 2rem">
                    <div class="form-label" style="font-size: 1.2rem">Inclusion Rules</div>
                </div>
                <div class="form-group" style="display: flex;align-items: center;margin-bottom: 2rem">
                    ${ this.tagTypeFieldsFilter.getHtmlBuild()}              
                    <div class="w-tooltips-adv pos-top short" style="margin: 1rem 0 0 1rem">
                        ${ this.tooltip.getHtmlBuild() }
                    </div>
                </div>
                
                <div class="form-group" data-bind="css: {'is-hidden': hideTagSearch()}" style="display: flex;">
                    <div style="width: calc(100% - 3rem);margin-right: 1rem">
                        ${ this.tagFilter.getHtmlBuild()}
                    </div>
                    <button class="btn border only-icon icon i-plus" type="button" data-bind="event: { click: onClickAddInclusionRule}, disable: disableAddBtn()" />
                </div>
                
                
                <table class="list-action" style="border-top: 1px solid #efefef;" data-bind="css: {'is-hidden': inclusionRules().length == 0 }">
                    <thead>
                        <tr>
                            <td><span>Specification Field</span></td>
                            <td><span>Specification Value</span></td>
                            <td><span></span></td>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: inclusionRules">
                        <tr>
                            <td><span data-bind="text: $data.field.name "></span></td>
                            <td><span data-bind="text: $data.tag.name "></span></td>
                            <td class="align-right"><button class="btn border only-icon highlight icon i-delete" data-bind="event: {click: $parent.onClickRemoveInclusionRule }"></button></td>
                        </tr>
                    </tbody>
                </table>
            `;
    }


    // implementation of base class [vnTemplate]
    protected initPartial(): void {

        this.tagTypeFieldsFilter = new filterDropdown_template('inclusionRuleTagTypeFieldsFilter', this.getTemplateViewModel(), this.caller);
        this.tagFilter = new filterTag_template("inclusionRuleTagFilter", this.getTemplateViewModel(), this.caller);

        this.inclusionRuleTooltipContent = `
        <p>
        Inclusion rules limit the tags that will appear on the listing page, this is optional.  Each inclusion rule is a specification and value required by the tags to appear on the page.
        </p>
        <ul>
            <li>Multiple inclusion rules can be added.  Tags with specification values that match at least one inclusion rule, will be included on the listing page.</li>
            <li>If there are inclusion rules for multiple specifications, the tags would need at least one value to match per specification.</li>
        </ul>       
        `

        this.tooltip = new infoButton_template('level1FilterTooltip', this.getTemplateViewModel(), this.caller)
        this.tooltip.setTitle('Inclusion Rules');
        this.tooltip.setContent(this.inclusionRuleTooltipContent);


    }


    // implementation of base class [vnTemplate]
    protected getTemplateName(): string {
        return 'inclusionRules_template';
    }


    // implementation of base class [vnTemplate]
    protected getMainElementClasses(): Array<string> {
        return [];
    }


    // implementation of base class [vnTemplate]
    public activateLoading() {
        this.getTemplateViewModel().isLoading(1);
    }

    //
    // implementation of base class [vnTemplate]
    public deactivateLoading() {

        this.getTemplateViewModel().isLoading(0);
    }

    public buildViewModel() {

        let self = this;
        return {
            inclusionRules: ko.observableArray([]),
            inclusionRulesToDelete: ko.observableArray([]),
            disableAddBtn: ko.observable(true),
            hideTagSearch: ko.observable(true),
            onClickAddInclusionRule: (data, event) => {
                self.onClickAddInclusionRule();
            },
            onClickRemoveInclusionRule: (data, event) => {
                self.onClickRemoveInclusionRule(data);
            }
        };
    }


    public onClickAddInclusionRule(): void {

        let optionId = this.getSelectedFieldOptionId();

        let field = this.getSelectedFieldObject(optionId);
        let tag = this.getTagObject();

        this.addInclusionRule({
            id: null,
            field: {
                id: field.id,
                name: field.name
            },
            tag: {
                id: tag.id,
                name: `${tag.name} ${tag.formattedTagTypeAndDataset}`
            }
        });

        this.tagFilter.clearInput();
    }

    public getSelectedFieldOptionId() {
        return this.tagTypeFieldsFilter.getTemplateViewModel().selectedOption();
    }

    public onClickRemoveInclusionRule(data): void {

        this.removeInclusionRule(data);
    }



    public removeInclusionRule(inclusionRule): void {

        let inclusionRules = this.getTemplateViewModel().inclusionRules();
        let inclusionRulesToKeep  = inclusionRules.filter((ir) => {
            return (ir.field.id != inclusionRule.field.id) || (ir.tag.id != inclusionRule.tag.id)
        });

        this.getTemplateViewModel().inclusionRules(inclusionRulesToKeep);

        let inclusionRulesToDelete = this.getTemplateViewModel().inclusionRulesToDelete();
        if (inclusionRule.id != null) {

            inclusionRulesToDelete.push(inclusionRule);
        }

        this.getTemplateViewModel().inclusionRulesToDelete(inclusionRulesToDelete);
    }


    public getSelectedFieldObject(optionId) {

        let fields = this.getFieldOptions()
            .filter((f) => f.id == optionId);

        return fields[0];
    }

    public getTagObject() {
        return this.tagFilter.getTemplateViewModel().tagObj();
    }

    public getFieldOptions() {

        return this.tagTypeFieldsFilter.getTemplateViewModel().options();
    }


    public addInclusionRule(inclusionRule): void {


        let inclusionRules = this.getTemplateViewModel().inclusionRules();

        let setAlready = inclusionRules.filter((ir) => {
            return (ir.field.id == inclusionRule.field.id) && (ir.tag.id == inclusionRule.tag.id)
        });

        if (setAlready.length == 0) {

            inclusionRules.push(inclusionRule);
        }

        this.getTemplateViewModel().inclusionRules(inclusionRules);
    }

    //
    // implementation of base class [vnTemplate]
    public getRequestParameters() {

        let inclusionRules = this.getTemplateViewModel().inclusionRules();
        let inclusionRulesToDelete = this.getTemplateViewModel().inclusionRulesToDelete();
        let parameters = {
            'save': [],
            'delete': []
        };

        inclusionRules.forEach((ir) => {
            parameters.save.push({id: ir.id, idTag: ir.tag.id, idField: ir.field.id});
        });
        inclusionRulesToDelete.forEach((ir) => {
            parameters.delete.push({id: ir.id, idTag: ir.tag.id, idField: ir.field.id});
        });

        return parameters;
    }

    public setInclusionRules(inclusionRules: Array<InclusionRule>): void {


        if (inclusionRules.length ==  0) {
            return;
        }

        let formattedInclusionRules = new Array();
        inclusionRules.forEach((ir) => {

            formattedInclusionRules.push({
                id: ir.id,
                field: {
                    id: ir.field.id,
                    name: ir.field.label
                },
                tag: {
                    id: ir.tag.id,
                    name: `${ir.tag.name} ${ir.tag.type ? ir.tag.formattedTagTypeAndDataset : ''}`
                }
            });
        });

        this.getTemplateViewModel().inclusionRules(formattedInclusionRules);
    }

    public setTagTypeFields(fields): void {


        let fieldOptions = [{id: 0, name: 'Select'}];
        for(let field of fields){

            fieldOptions.push({id: field.id, name: field.label});
        }

        this.tagTypeFieldsFilter.setOptions(fieldOptions);
    }

    public setTags(tags): void {

        this.tagFilter.getTemplateViewModel().tags(tags);
    }

    public reset(): void {
        this.resetFields();
        this.resetInclusionRules();
        this.resetTags();
    }

    private resetTags(): void {
        this.tagFilter.getTemplateViewModel().tags([]);
    }

    private resetInclusionRules(): void {
        this.getTemplateViewModel().inclusionRules([]);
    }

    private resetFields(): void {
        this.tagTypeFieldsFilter.setOptions([]);
    }

    public handleState(idElement: string): void {

        let optionId = this.tagTypeFieldsFilter.getTemplateViewModel().selectedOption();
        let tag = this.getTagObject();

        if (optionId != 0) {

            this.getTemplateViewModel().hideTagSearch(false);
            if (tag != null && tag != '') {

                this.getTemplateViewModel().disableAddBtn(false);
            } else {

                this.getTemplateViewModel().disableAddBtn(true);
            }

        } else {

            if (tag != null && tag != '') {

                this.tagFilter.clearInput();
                this.getTemplateViewModel().disableAddBtn(true);
            } else {

                this.getTemplateViewModel().disableAddBtn(false);
            }

            this.getTemplateViewModel().hideTagSearch(true);

        }
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/inclusionRules_template.ts